<app-countries-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [hideLabel]="true"
  [parentFormGroup]="form"
  class="kendo-select-filter"
>
</app-countries-select>
